import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {FlatButton} from '@pb/kit-component-button';

import {
    notificationsListStateActions, notificationsListStateSelector,
} from '../../slices/notification-search-criteria.slice';


export const ClearFilters = () => {
    const dispatch = useDispatch();
    const state = useSelector(notificationsListStateSelector);

    const clearAllFiltersHandler = useCallback(() => {
        dispatch(notificationsListStateActions.setFilters({}));
    }, [dispatch]);

    return (
        <FlatButton
            disabled={!Object.keys(state.filters).length}
            onClick={clearAllFiltersHandler}>
            <strong>
                Clear All Filters
            </strong>
        </FlatButton>
    );
};
